import {
  dbRefs,
  firestoreRef,
  firestoreChangeTypes,
} from "../services/firebase/init";

export default {
  data() {
    return {
      dbRefs,
      firestoreRef,
      firestoreChangeTypes,
    };
  },
  methods: {
    async saveData(ref, form) {
      try {
        this.$store.commit("flipSaving");
        await ref.add({ ...form });
        this.$store.commit("flipSaving", false);
        this.notifyOk();
        if (form) {
          this.resetForm(form);
        }
      } catch (e) {
        this.notifyErr();
      }
    },
    async updateData(ref, payload, form, load = true) {
      let target = null;
      try {
        if (load) {
          if (window.event.target.querySelector) {
            target = window.event.target.querySelector("button");
            if (target) {
              this.showLoader(target);
            }
          }
        }
        this.$store.commit("flipSaving");
        await ref.set({ ...payload }, { merge: true });
        this.$store.commit("flipSaving", false);
        this.notifyOk();
        if (form) {
          this.resetForm(form);
        }
      } catch (e) {
        console.log(e, "err");
        this.notifyErr();
      } finally {
        if (target) {
          this.hideLoader(target);
        }
      }
    },
    async deleteData(ref) {
      try {
        await ref.delete();
        this.notifyOk("Deleted successfully");
      } catch (e) {
        this.notifyErr();
      }
    },
    async saveToArray({ ref, key, value, resetForm = true }) {
      try {
        this.$store.commit("flipSaving");
        await ref.update({
          [`${key}`]: this.firestoreRef.FieldValue.arrayUnion(value),
        });
        this.$store.commit("flipSaving", false);
        this.notifyOk();
        if (resetForm) {
          this.resetForm(value);
        }
      } catch (e) {
        this.notifyErr();
      }
    },
    async removeFromArray({ ref, key, value, notify = true }) {
      try {
        await ref.update({
          [`${key}`]: this.firestoreRef.FieldValue.arrayRemove(value),
        });
        if (notify) {
          this.notifyOk();
        }
      } catch (e) {
        if (notify) {
          this.notifyErr();
        }
      }
    },
    async updateArrayElem({ ref, key, beforeVal, afterVal }) {
      try {
        const payload = {
          ref,
          key,
        };
        await this.removeFromArray({
          ...payload,
          value: beforeVal,
          notify: false,
        });
        await this.saveToArray({
          ...payload,
          value: afterVal,
          resetForm: false,
        });
      } catch (e) {
        throw e;
        // this.notifyErr(e.message);
      }
    },
    resetForm(form) {
      Object.keys(form).forEach((key) => {
        form[key] = "";
      });
    },
    notifyOk(message) {
      this.$toasted.success(message || "Saved successfully");
    },
    notifyErr(message) {
      this.$toasted.error(message || "Something went wrong");
    },
  },
  watch: {
    // saving: function (newValue, oldValue) {
    //   const target = window.event.target.querySelector('button')
    //   console.log(target, 'target')
    //   if (newValue) {
    //     this.showLoader(target)
    //   } else {
    //     this.hideLoader(target)
    //   }
    // }
  },
};
